import Vue from 'vue';
import moment from 'moment';

export function removeVuetifyCalendarError() {
  const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
  // eslint-disable-next-line no-unused-vars
  Vue.config.warnHandler = function (msg, vm, trace) {
    if (msg === ignoreWarnMessage) {
      msg = null;
      vm = null;
      trace = null;
    }
  };
}

export function sortArrayObjectByDate(arrObj) {
  const sortedArray = arrObj.sort(
    (a, b) => moment(a.registerDate, 'YYYY-MM-DDTHH:mm').format('YYYYMMDDHHmm') - moment(b.registerDate, 'YYYY-MM-DDTHH:mm').format('YYYYMMDDHHmm')
  );
  return sortedArray;
}

export function validateAzvNumber(number) {
  //only digits in string allowed
  if (!/^\d+$/.test(number)) return false;
  number = parseInt(number);
  if (Number.isInteger(number)) {
    number = number / 100;
    //check if can be divided by 100
    if (!Number.isInteger(number)) return false;
    const result =
      (getNumberFromIndex({ number: number, index: 0 }) * 8 +
        getNumberFromIndex({ number: number, index: 1 }) * 7 +
        getNumberFromIndex({ number: number, index: 2 }) * 6 +
        getNumberFromIndex({ number: number, index: 3 }) * 5 +
        getNumberFromIndex({ number: number, index: 4 }) * 4 +
        getNumberFromIndex({ number: number, index: 5 }) * 3 +
        getNumberFromIndex({ number: number, index: 6 }) * 2 +
        getNumberFromIndex({ number: number, index: 7 }) * 1) /
      11;
    if (Number.isInteger(result)) return true;
    else return false;
  } else {
    return false;
  }
}

export function getNumberFromIndex(set) {
  const numberString = set.number.toString();
  return parseInt(numberString[set.index]);
}
